import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useEffect, useState } from "react";

function HomepageTileDialog({ onClose, onConfirm, mode = "add", initialName = "" }) {
  const [tileName, setTileName] = useState(initialName);

  useEffect(() => {
    setTileName(initialName);
  }, [mode, initialName]);

  useEffect(() => {
    const input = document.getElementById("tile-name-input");
    if (input) {
      input.focus();
      input.select();
    }
  }, [mode]);

  const handleConfirm = () => {
    if (tileName.trim()) {
      onConfirm(tileName.trim());
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleConfirm();
    }
  };

  const getTitle = () => {
    return mode === "edit" ? "Edit Tile" : "Add New Tile";
  };

  const getButtonText = () => {
    return mode === "edit" ? "Save" : "Add Tile";
  };

  const getMessage = () => {
    return mode === "edit"
      ? "Enter the new name for the tile:"
      : "Enter the name for the new tile:";
  };

  return (
    <Dialog
      title={getTitle()}
      onClose={onClose}
      width={400}
    >
      <div style={{ margin: "25px", textAlign: "center" }}>
        <p style={{ fontSize: 16, marginBottom: "15px" }}>{getMessage()}</p>
        <input
          id="tile-name-input"
          type="text"
          value={tileName}
          onChange={(e) => setTileName(e.target.value)}
          placeholder="Tile name"
          style={{
            width: "100%",
            padding: "8px 12px",
            fontSize: "14px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            outline: "none",
          }}
          onKeyDown={handleKeyDown}
        />
      </div>
      <DialogActionsBar>
        <Button
          className="k-button"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          className="k-button"
          themeColor="primary"
          onClick={handleConfirm}
          disabled={!tileName.trim()}
        >
          {getButtonText()}
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
}

export default HomepageTileDialog;
